/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIGovernanceRequestBase {
    getFixupPrototypeFunction() { return AIGovernanceRequestBase.fixupPrototype; }

    static newInstance(model: Partial<AIGovernanceRequestBase>): AIGovernanceRequestBase {
        let obj = Object.assign(new AIGovernanceRequestBase(), model);
        AIGovernanceRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIGovernanceRequestBase>): AIGovernanceRequestBase {
        if (!model) return null;
        return AIGovernanceRequestBase.newInstance(<AIGovernanceRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIGovernanceRequestBase) {
        if (!obj) return;

        models.AIGovernanceRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIGovernanceRequestBase): boolean {
        Object.setPrototypeOf(obj, AIGovernanceRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Query operator for filtering
     */
    filters: models.QueryOperator;

    /**
     * Start date for metrics
     */
    start_date: Date;

    /**
     * End date for metrics
     */
    end_date: Date;

}
